export default __webpack_public_path__ + "static/coin-803eee89e3d06c86fee44cfd7d08cca4.svg";